module.exports = __webpack_public_path__ + "image/dy-ewm.png";